var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.result.data.length === 0 ? _c("result-not-found") : _vm._e(),
      _vm._l(_vm.result.data, function(admission, admissionindex) {
        return _c(
          "div",
          { key: `admission-item-${admissionindex}` },
          [
            _c("board", {
              staticClass: "mb-1 c-board",
              attrs: { details: admission.boardData }
            }),
            _vm._l(admission.calloutData, function(item, index) {
              return _c(
                "div",
                { key: `referral-item-${index}` },
                [
                  _c(
                    "callout",
                    {
                      class: {
                        "mb-3":
                          !item.startDateError &&
                          !item.endDateError &&
                          !item.dateRangeError &&
                          item.errors.length == 0
                      },
                      attrs: {
                        "apply-border-top": "",
                        "border-top-color": "#D9AE8E",
                        controlled: true,
                        "has-toggle": true,
                        opened: item.isOpen
                      },
                      on: {
                        "click:open": function($event) {
                          return _vm.onOpenDetails(item, admissionindex, index)
                        }
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "edition",
                            fn: function() {
                              return [
                                _c("div", { staticClass: "bg-gray p-2" }, [
                                  _c(
                                    "div",
                                    { staticClass: "bg-white rounded" },
                                    [
                                      _c(
                                        "b-tabs",
                                        {
                                          attrs: {
                                            "content-class": "mt-3",
                                            "nav-class": "custom-nav-container",
                                            "no-nav-style": true
                                          }
                                        },
                                        [
                                          _c(
                                            "b-tab",
                                            {
                                              attrs: {
                                                active: "",
                                                lazy: "",
                                                title: "Información General"
                                              }
                                            },
                                            [
                                              _c("general-info", {
                                                attrs: { info: item }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "b-tab",
                                            {
                                              attrs: { title: "Visitas" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.onActivateVisitTabHandler(
                                                    item
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("visit", {
                                                attrs: {
                                                  pagination:
                                                    _vm.visitHistoryPagination,
                                                  visits:
                                                    _vm.visitsHistoryPaginated
                                                },
                                                on: {
                                                  "page-change":
                                                    _vm.onVisitHistoryPageChangeHandler
                                                }
                                              }),
                                              _vm.canShowVisitHistoryPagination
                                                ? _c("pagination", {
                                                    attrs: {
                                                      data:
                                                        _vm.visitHistoryPagination
                                                    },
                                                    on: {
                                                      "pagination-go-page":
                                                        _vm.onVisitHistoryPageChangeHandler
                                                    }
                                                  })
                                                : _vm._e()
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ])
                              ]
                            },
                            proxy: true
                          }
                        ],
                        null,
                        true
                      )
                    },
                    [
                      _c("div", { staticClass: "row" }, [
                        _c(
                          "div",
                          { staticClass: "col-md-3 mt-2 c-baloonPlusNumber" },
                          [
                            _c("ballon", {
                              staticClass: "mt-2 p-0 font-weight-bold font-16",
                              attrs: {
                                "background-color": `text-center font-14 border-none bg-${_vm.getStatusColor(
                                  item.statusId
                                )}`,
                                text: item.status
                              }
                            }),
                            _c("div", { staticClass: "ml-4 pl-2 mt-2" }, [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "color-secondary-6 font-14 text-left font-weight-normal"
                                },
                                [_vm._v(" No. ")]
                              ),
                              _c(
                                "label",
                                {
                                  staticClass:
                                    "color-black font-16 font-weight-bold"
                                },
                                [_vm._v(" " + _vm._s(item.number) + " ")]
                              )
                            ])
                          ],
                          1
                        ),
                        _c("div", {
                          staticClass: "col-12 horizontalDivider d-md-none"
                        }),
                        _c("div", { staticClass: "col-md-9 py-3 px-4" }, [
                          _c(
                            "div",
                            { staticClass: "row c-customDatePickers" },
                            [
                              _c("div", { staticClass: "col-md-2" }, [
                                item.statusId ==
                                _vm.AdmissionStatus.NoVigenteTraslado
                                  ? _c("div", { staticClass: "mb-3 mb-md-0" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "font-weight-normal font-14 color-secondary-6"
                                        },
                                        [_vm._v(" Tipo: ")]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "font-weight-normal font-16 color-black"
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(item.type || "-") + " "
                                          )
                                        ]
                                      )
                                    ])
                                  : _vm._e()
                              ]),
                              _c(
                                "div",
                                { staticClass: "col-md-2 mb-3 mb-md-0" },
                                [
                                  _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "font-weight-normal font-14 color-secondary-6"
                                      },
                                      [_vm._v(" Visitas: ")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "font-weight-normal font-16 color-black"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              item.admissionVisitCount || "-"
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "col-md-2 mb-3 mb-md-0" },
                                [
                                  item.statusId ==
                                  _vm.AdmissionStatus.NoVigenteTraslado
                                    ? _c("div", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "font-weight-normal font-14 color-secondary-6"
                                          },
                                          [_vm._v(" Fecha de Manejo: ")]
                                        ),
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "font-weight-normal font-16 color-black"
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm._f("date")(item.date)
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ])
                                    : _vm._e()
                                ]
                              ),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "col-6 col-sm col-12 mb-3 mb-md-0"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "font-weight-normal font-14 color-secondary-6"
                                    },
                                    [_vm._v(" Fecha Desde: ")]
                                  ),
                                  _c("custom-date-picker", {
                                    staticClass: "customDatePicker",
                                    attrs: {
                                      disabled: !_vm.canEditVigency,
                                      error: item.startDateError ? "error" : "",
                                      placeholder: "DD/MM/YYYY"
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.onDateChange(
                                          admissionindex,
                                          index,
                                          "start"
                                        )
                                      }
                                    },
                                    model: {
                                      value: item.startDate,
                                      callback: function($$v) {
                                        _vm.$set(item, "startDate", $$v)
                                      },
                                      expression: "item.startDate"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "col-6 col-sm col-12 col-md-3" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "font-weight-normal font-14 color-secondary-6"
                                    },
                                    [_vm._v(" Fecha Hasta: ")]
                                  ),
                                  _c("custom-date-picker", {
                                    staticClass: "customDatePicker",
                                    attrs: {
                                      error: item.endDateError ? "error" : "",
                                      placeholder: "DD/MM/YYYY"
                                    },
                                    on: {
                                      input: function($event) {
                                        return _vm.onDateChange(
                                          admissionindex,
                                          index,
                                          "end"
                                        )
                                      }
                                    },
                                    model: {
                                      value: item.endDate,
                                      callback: function($$v) {
                                        _vm.$set(item, "endDate", $$v)
                                      },
                                      expression: "item.endDate"
                                    }
                                  })
                                ],
                                1
                              )
                            ]
                          ),
                          _c(
                            "div",
                            { staticClass: "row mt-2 c-customDatePickers" },
                            [
                              _c("div", { staticClass: "col-md-2" }),
                              _c(
                                "div",
                                { staticClass: "col-md-4 mb-3 mb-md-0" },
                                [
                                  _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "font-weight-normal font-14 color-secondary-6"
                                      },
                                      [_vm._v(" Especialista de Admisión: ")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "font-weight-normal font-16 color-black"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              item.assignmentSpecialistFullName ||
                                                "-"
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "div",
                                { staticClass: "col-md-4 mb-3 mb-md-0" },
                                [
                                  _c("div", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "font-weight-normal font-14 color-secondary-6"
                                      },
                                      [_vm._v(" Especialista de Servicio: ")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "font-weight-normal font-16 color-black"
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm._f("'-'")(
                                                item.admissionSpecialistFullName
                                              )
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ])
                                ]
                              )
                            ]
                          )
                        ])
                      ])
                    ]
                  ),
                  _vm.hasReferralError(item)
                    ? _c(
                        "div",
                        {
                          staticClass: "bg-secondary-10 p-2 rounded-bottom mb-3"
                        },
                        [
                          item.startDateError || item.endDateError
                            ? _c("error", {
                                attrs: {
                                  message: "Favor de entrar fecha desde/hasta.",
                                  variant: "no-border"
                                }
                              })
                            : _vm._e(),
                          item.dateEndRangeError &&
                          !(item.startDateError || item.endDateError)
                            ? _c("error", {
                                attrs: {
                                  message:
                                    "Fecha de vigencia hasta no puede ser menor a la desde.",
                                  variant: "no-border"
                                }
                              })
                            : _vm._e(),
                          item.dateStartRangeError &&
                          !(item.startDateError || item.endDateError)
                            ? _c("error", {
                                attrs: {
                                  message:
                                    "Fecha de vigencia desde no puede ser mayor a la hasta.",
                                  variant: "no-border"
                                }
                              })
                            : _vm._e(),
                          item.errors.length > 0
                            ? _c(
                                "div",
                                _vm._l(item.errors, function(
                                  errItem,
                                  errIndex
                                ) {
                                  return _c("error", {
                                    key: `err-${errIndex}`,
                                    attrs: {
                                      message: errItem,
                                      variant: "no-border"
                                    }
                                  })
                                }),
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            })
          ],
          2
        )
      }),
      _vm.showPagination
        ? _c("pagination", {
            attrs: { data: _vm.resultSearch.pagination, "show-text": true },
            on: { "pagination-go-page": _vm.onPageChange }
          })
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }